exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed[data-v-019ede26] {\n  z-index: 99;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.foodNav[data-v-019ede26] {\n  height: 2.7rem;\n}\n.foodNav .kf[data-v-019ede26] {\n  width: 3.5rem;\n  position: relative;\n}\n.foodNav .kf[data-v-019ede26]::after {\n  content: \"\";\n  height: 2.2rem;\n  width: 0.05rem;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-image: linear-gradient(to right, #CACACA 50%, transparent 50%);\n  display: block;\n}", ""]);

// exports
